document.addEventListener('DOMContentLoaded', () => {

    function updateVariantInURL(variantId) {
        const url = new URL(window.location);
        url.searchParams.set("variant", variantId);
        window.history.pushState({}, '', url);
        console.log("URL updated with variant:", url.toString());
    }

    function syncVariantToForm(variantId) {
        const formInputs = document.querySelectorAll('.form-id-input');
        formInputs.forEach(input => {
            input.value = variantId;
        });
    }

    const labels = document.querySelectorAll(".radio-button-container");
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromURL = urlParams.get("variant");

    if (variantFromURL) {
        labels.forEach(label => {
            const variantId = label.getAttribute("data-variant-id");
            const input = label.querySelector('input[type="radio"]');

            if (variantId === variantFromURL) {
                label.classList.add("active");
                input.checked = true;
                syncVariantToForm(variantId);
            } else {
                label.classList.remove("active");
                input.checked = false;
            }
        });
    } else {
        const activeLabel = document.querySelector(".radio-button-container");
        if (activeLabel) {
            activeLabel.classList.add("active");
            const input = activeLabel.querySelector('input[type="radio"]');
            if (input) input.checked = true;

            const variantId = activeLabel.getAttribute("data-variant-id");
            updateVariantInURL(variantId);
            syncVariantToForm(variantId);
        }
    }


    labels.forEach(label => {
        label.addEventListener("click", () => {
            labels.forEach(l => {
                l.classList.remove("active");
                const input = l.querySelector('input[type="radio"]');
                if (input) input.checked = false;
            });

            label.classList.add("active");
            const input = label.querySelector('input[type="radio"]');
            if (input) input.checked = true;

            const variantId = label.getAttribute("data-variant-id");
            updateVariantInURL(variantId);
            syncVariantToForm(variantId);
        });
    });


    const quantityContainers = document.querySelectorAll(".BuildItemQuantity");
    const addToCartFormBuildBundle = document.querySelector('.add-to-cart-form');
    const addToCartMobileFormBuildBundle = document.querySelector('.add-to-cart-form-mobile');

    const rangefinderCheckboxes = document.querySelectorAll('.RangefinderCheckbox');

    const radioContainers = document.querySelectorAll('.radio-button-container');
    if (radioContainers) {
        radioContainers.forEach(container => {
            container.addEventListener('click', function () {
                radioContainers.forEach(item => item.classList.remove('active'));

                this.classList.add('active');

                //const free_product_id = this.getAttribute('data-variant-id');
                const variantID = this.getAttribute('data-variant-id');
                const formVariantIDInput = document.querySelectorAll('.form-id-input');

                formVariantIDInput.forEach(node => {
                    node.value = variantID;
                });

                /*clearExistingInputs(addToCartFormBuildBundle);
                clearExistingInputs(addToCartMobileFormBuildBundle);

                addInputsToForm(addToCartFormBuildBundle, free_product_id);
                addInputsToForm(addToCartMobileFormBuildBundle, free_product_id);*/
            });
        });
    }


    quantityContainers.forEach(container => {
        const decreaseButton = container.querySelector(".QuantityButton#decrease");
        const increaseButton = container.querySelector(".QuantityButton#increase");
        const quantityValue = container.querySelector(".QuantityValue");
        const minusIcon = decreaseButton.querySelector("g");

        const checkbox = container.closest('.BuildYourBundleItem').querySelector('.BuildYourBundleCheck');

        let quantity = 0;

        decreaseButton.addEventListener("click", function () {
            if (quantity > 0) {
                quantity--;
                quantityValue.textContent = quantity;

                if (quantity === 0) {
                    decreaseButton.disabled = true;
                    minusIcon.setAttribute("opacity", "0.4");

                    checkbox.checked = false;
                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });

        increaseButton.addEventListener("click", function () {
            quantity++;
            quantityValue.textContent = quantity;

            if (quantity > 0) {
                decreaseButton.disabled = false;
                minusIcon.setAttribute("opacity", "1");

                if (!checkbox.checked) {
                    checkbox.checked = true;
                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });

        checkbox.addEventListener("change", function () {
            if (checkbox.checked) {

                if (quantity === 0) {
                    quantity = 1;
                    quantityValue.textContent = quantity;
                    decreaseButton.disabled = false;
                    minusIcon.setAttribute("opacity", "1");
                }
            } else {

                quantity = 0;
                quantityValue.textContent = quantity;
                decreaseButton.disabled = true;
                minusIcon.setAttribute("opacity", "0.4");
            }
            updatePricesAndCart();
        });
    });

    const checkboxes = document.querySelectorAll('.BuildYourBundleCheck');
    const stickyProductPriceElement = document.querySelector('.sticky-product-price');

    const mobileAddToCartButton = document.querySelector('.add-to-bag-mobile');
    const stickyProductTitle = document.querySelector('.sticky-product-title');

    if (checkboxes) {
        let basePrice = 0;
        let baseProductTitle = '';

        if (stickyProductPriceElement) {
            const basePriceData = stickyProductPriceElement.getAttribute('data-base-price');
            if (basePriceData) {
                basePrice = parseFloat(basePriceData.replace(/[^0-9.-]+/g, "")) || 0;
            } else {
                basePrice = 0;
            }
        }


        if (stickyProductTitle) {
            baseProductTitle = stickyProductTitle.textContent.trim();
        }

        function formatPrice(amount) {
            return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(amount);
        }

        function updatePricesAndCart() {
            let bundleTotal = 0;
            let selectedItems = [];

            const existingInputs = addToCartFormBuildBundle.querySelectorAll('.ProProductInput');
            existingInputs.forEach(input => input.remove());

            let currentIndex = 3;

            checkboxes.forEach(function (checkbox) {
                const item = checkbox.closest('.BuildYourBundleItem');

                if (checkbox.checked && item) {
                    const priceStr = item.getAttribute('data-price') || "0";
                    const price = parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;

                    const quantityContainer = item.querySelector(".BuildItemQuantity");
                    const quantityValue = quantityContainer.querySelector(".QuantityValue");
                    let quantity = parseInt(quantityValue.textContent) || 1;

                    bundleTotal += price * quantity;
                    const productId = item.getAttribute('data-id');

                    let inputNode = document.createElement('input');
                    inputNode.setAttribute('type', 'hidden');
                    inputNode.setAttribute('name', `items[${currentIndex}][id]`);
                    inputNode.setAttribute('value', productId);
                    inputNode.setAttribute('class', 'ProProductInput');
                    addToCartFormBuildBundle.appendChild(inputNode);

                    let inputNodeQuantity = document.createElement('input');
                    inputNodeQuantity.setAttribute('type', 'hidden');
                    inputNodeQuantity.setAttribute('name', `items[${currentIndex}][quantity]`);
                    inputNodeQuantity.setAttribute('value', quantity);
                    inputNodeQuantity.setAttribute('class', 'ProProductInput');
                    addToCartFormBuildBundle.appendChild(inputNodeQuantity);

                    currentIndex++;

                    selectedItems.push({
                        title: item.getAttribute('data-product-title'),
                        price: price,
                        quantity: quantity
                    });
                }
            });

            // Add Rangefinder
            rangefinderCheckboxes.forEach((rangefinderCheckbox) => {
                if (rangefinderCheckbox.checked) {
                    let inputNode = document.createElement('input');
                    inputNode.type = 'hidden';
                    inputNode.name = `items[${currentIndex}][id]`;
                    inputNode.value = rangefinderCheckbox.dataset.id;
                    inputNode.className = 'ProProductInput';
                    addToCartFormBuildBundle.appendChild(inputNode);

                    let qtyNode = document.createElement('input');
                    qtyNode.type = 'hidden';
                    qtyNode.name = `items[${currentIndex}][quantity]`;
                    qtyNode.value = 1;
                    qtyNode.className = 'ProProductInput';
                    addToCartFormBuildBundle.appendChild(qtyNode);

                    currentIndex++;

                    const price =
                        parseFloat(rangefinderCheckbox.dataset.price || 0) / 100;

                    bundleTotal += price;

                    const title =
                        rangefinderCheckbox
                            .closest('.RangefinderCard')
                            ?.querySelector('.RangefinderName')
                            ?.textContent.trim() || 'Rangefinder';

                    selectedItems.push({
                        title,
                        price,
                        quantity: 1
                    });
                }
            });

            const totalPrice = basePrice + bundleTotal;

            if (stickyProductPriceElement) {
                stickyProductPriceElement.textContent = formatPrice(totalPrice);
            }

            if (stickyProductTitle) {
                let newTitle = baseProductTitle;

                if (selectedItems.length > 0) {
                    const selectedProductTitles = selectedItems.map(item => `${item.title}`).join(' + ');
                    newTitle += ' + ' + selectedProductTitles;
                }

                stickyProductTitle.textContent = newTitle;
            }

            if (addToCartMobileFormBuildBundle) {
                const mobileExistingInputs = addToCartMobileFormBuildBundle.querySelectorAll('.ProProductInput');
                mobileExistingInputs.forEach(input => input.remove());

                let mobileCurrentIndex = 3;

                checkboxes.forEach(function (checkbox) {
                    const item = checkbox.closest('.BuildYourBundleItem');
                    if (checkbox.checked && item) {
                        const priceStr = item.getAttribute('data-price') || "0";
                        const price = parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;

                        const quantityContainer = item.querySelector(".BuildItemQuantity");
                        const quantityValue = quantityContainer.querySelector(".QuantityValue");
                        let quantity = parseInt(quantityValue.textContent) || 1;

                        const productId = item.getAttribute('data-id');

                        let inputNode = document.createElement('input');
                        inputNode.setAttribute('type', 'hidden');
                        inputNode.setAttribute('name', `items[${mobileCurrentIndex}][id]`);
                        inputNode.setAttribute('value', productId);
                        inputNode.setAttribute('class', 'ProProductInput');
                        addToCartMobileFormBuildBundle.appendChild(inputNode);

                        let inputNodeQuantity = document.createElement('input');
                        inputNodeQuantity.setAttribute('type', 'hidden');
                        inputNodeQuantity.setAttribute('name', `items[${mobileCurrentIndex}][quantity]`);
                        inputNodeQuantity.setAttribute('value', quantity);
                        inputNodeQuantity.setAttribute('class', 'ProProductInput');
                        addToCartMobileFormBuildBundle.appendChild(inputNodeQuantity);

                        mobileCurrentIndex++;
                    }
                });

                rangefinderCheckboxes.forEach((rangefinderCheckbox) => {
                    if (rangefinderCheckbox.checked) {
                        let inputNode = document.createElement('input');
                        inputNode.type = 'hidden';
                        inputNode.name = `items[${mobileCurrentIndex}][id]`;
                        inputNode.value = rangefinderCheckbox.dataset.id;
                        inputNode.className = 'ProProductInput';
                        addToCartMobileFormBuildBundle.appendChild(inputNode);

                        let qtyNode = document.createElement('input');
                        qtyNode.type = 'hidden';
                        qtyNode.name = `items[${mobileCurrentIndex}][quantity]`;
                        qtyNode.value = 1;
                        qtyNode.className = 'ProProductInput';
                        addToCartMobileFormBuildBundle.appendChild(qtyNode);

                        mobileCurrentIndex++;
                    }
                });
            }

            if (mobileAddToCartButton) {
                const baseText = mobileAddToCartButton.getAttribute('data-base-text') || 'ADD TO CART - ';
                mobileAddToCartButton.textContent = `${baseText}${formatPrice(totalPrice)}`;
            }
        }

        if (checkboxes.length > 0 && stickyProductPriceElement && addToCartFormBuildBundle) {

            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    const parentElement = this.closest('.BuildYourBundleItemContainer');

                    if (parentElement) {
                        parentElement.classList.toggle(
                            'active',
                            this.checked
                        );
                    }

                    updatePricesAndCart();
                });
            });

            rangefinderCheckboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    const card = this.closest('.RangefinderCard');

                    if (card) {
                        card.classList.toggle(
                            'active',
                            this.checked
                        );
                    }

                    updatePricesAndCart();
                });
            });

            updatePricesAndCart();
        }
    }

});